export const ENDPOINTS = {
  PRODUCT_CONFIG_API: "/resource/v1/get-product-config",
  TRANSLATION_API_URL: "/resource/v1/get-lang-config",
  BUNDLE_API_URL: `/product/API_VERSION/bundle`,
}

export const SUCCESS_UPPER = "SUCCESS"
export const BROADBAND_BREDBCUMB = [
  { label: "Home", path: "/" },
  { label: "Broadband", path: "/new-connection" },
  { label: "Internet Plans", path: "" },
]

export const CONFIG_KEY = {
  AWCONFIG: "AWCONFIG",
  PAYMENTCONFIG: "PAYMENTCONFIG",
  CALCCONFIG: "CALCCONFIG",
  UI_TRANSALTION: "ui-translations",
  ORPCONFIG: "ORPCONFIG",
  FAQ: "faq",
  GLOBAL_CONFIG: "GLOBALCONFIG",
  ORDER_STATUS_CONFIG: "orderStatusConfig",
  P3_AWCONFIG: "P3-AWCONFIG"
}

export const BTN_TYPE = {
  TRANSPARENT_WHITE: "transparentWhite",
  DANGER: 'danger',
  SECONDARY_BTN: "secondaryBtn"
}

export const COUNTRY_TEXT = "country"
export const LOCALITY_TEXT = "locality"
export const OK_TEXT = "OK"
export const CURRENT_ADD_KEY = "currentAdd"
export const BUTTON_TEXT = "button"
export const ADDRESS_TEXT = "address"
export const WEB_TEXT = "web"
export const LABEL_TEXT = "label"
export const ERROR_TEXT = 'error'
export const RESIZE_TEXT = "resize"
export const RECIEPT_PDF = "receipt-pdf"
export const TXN_RECIEPT_PDF = "transaction-receipt.pdf"
export const ID = "id"
export const FTT_TEXT = "FTT"
export const CONFIG_DATA_TEXT = "configData"
export const LANG_DATA_TEXT = "langData"
export const CALL_BACK = "callback"
export const LEAD_ID_GENERATED = "LEAD_ID_GENERATED"
export const FTTX_PLANS_HEADING = "FTTX_PLANS_HEADING"
export const GREAT_NEWS = "GREAT_NEWS"
export const TIP = "TIP"
export const CHECKING = "CHECKING"
export const FTTX_PLANS_SUBHEADING = "FTTX_PLANS_SUBHEADING"
export const FTTX_PLANS_PAGE = "FTTX_PLANS_PAGE"
export const POST = "POST"
export const PLAN = "PLAN"
export const BUY_NOW = "BUY_NOW"
export const COPIED = "COPIED"
export const FTTX_HOME_PAGE = "FTTX_HOME_PAGE"
export const HAVE_AN_QUESTION_TEXT = "HAVE_AN_QUESTION_TEXT"
export const CONTACT_US = "CONTACT_US"
export const NG = "NG"
export const GET = "GET";

export const PAY_FOR_INSTALLATION_TEXT = "PAY_FOR_INSTALLATION_TEXT"
export const SYSTEM_UNAVAILABLE_TITLE = "SYSTEM_UNAVAILABLE_TITLE";
export const SYSTEM_UNAVAILABLE_DESC = "SYSTEM_UNAVAILABLE_DESC";
export const ISSUE_NETWORK = "ISSUE_NETWORK";
export const ISSUE_MAINTENANCE = "ISSUE_MAINTENANCE";
export const ISSUE_SERVER_LOAD = "ISSUE_SERVER_LOAD";
export const WHAT_TO_DO = "WHAT_TO_DO";
export const BTN_RETRY = "BTN_RETRY";
export const BTN_HOME = "BTN_HOME";
export const SERVICE_STATUS_TITLE = "SERVICE_STATUS_TITLE";
export const SERVICE_STATUS_MSG = "SERVICE_STATUS_MSG";
export const REQUESTED = "requested"
export const SUCCESS = "success"
export const FAILED = "failed"
export const IN_PROGRESS = "in_progress"
export const IN_PROCESS = "in_process"
export const REQUEST_SUBMITTED = "REQUEST_SUBMITTED"
export const CONGRATULATIONS = "CONGRATULATIONS"
export const WHATSAPP_TEXT = "WHATSAPP_TEXT"
export const CALL_BACK_TEXT = "CALL_BACK_TEXT"
export const SUBMIT_REQUEST = "SUBMIT_REQUEST"
export const RECOMENDED = "RECOMENDED"
export const PROCESSING = "PROCESSING"
export const CLICK_HERE = "CLICK_HERE"
export const RETRY = "RETRY"
export const CUSTOMER = "CUSTOMER"
export const REQUIRED_FIELD_TEXT = "REQUIRED_FIELD_TEXT"
export const VALID_INPUT_TEXT = "VALID_INPUT_TEXT"
export const CHANGE_LOCATION = "CHANGE_LOCATION"

export const RETRYING = "RETRYING"
export const TRY_AGAIN = "TRY_AGAIN"
export const UPDATING_LOCATION = "UPDATING_LOCATION"

export const ORP_BASE_URL = "/api/portal-service"
export const BFE_BASE_URL = "/orp/bfe"

export const RETRY_STATUS_CODE = 8013
export const SUCCESS_CODE = 200

export const REGEX_FAILED = "regexError"
export const MAX_LENGTH_ERROR = "maxLengthError"
export const MIN_LENGTH_ERROR = "minLengthError"

export const VAILID_RESPONSE_TEXT = "VAILID_RESPONSE_TEXT"
export const MAX_LENGTH_ERROR_MSG = "MAX_LENGTH_ERROR_MSG"
export const MIN_LENGTH_ERROR_MSG = "MIN_LENGTH_ERROR_MSG"

export const MORE = "MORE"
export const BACK = "BACK"
export const COPY_ORDER_ID = "COPY_ORDER_ID"
export const SUBMITING = "SUBMITING"
export const SUBMIT = "SUBMIT"
export const DOWNLOADING = "DOWNLOADING"
export const USE_THIS_ADDRESS = "USE_THIS_ADDRESS"
export const SELECTED_ADDRESS = "SELECTED_ADDRESS"
export const CONFIRM_INSTALLATION_ADDRESS = "CONFIRM_INSTALLATION_ADDRESS"
export const CONFIRM_INSTALLATION_ADDRESS_DES = "CONFIRM_INSTALLATION_ADDRESS_DES"
export const HYBRID = "hybrid";
export const SOMETHING_WENT_WRONG = "Something Went Wrong!";
export const INVALID_MOBILE_NO = "Invalid Mobile No";
export const ERROR = "Error";
export const DANGER = "danger";
export const NO_SMARTCASH_ACCOUNT_TEXT = "NO_SMARTCASH_ACCOUNT_TEXT";
export const NIGERIA_IMAGES_PATH = "nigeria/assets/images";


export const DRC = "drc";
export const GA = "GA";
export const UG = "UG";
export const CG = "CG";
export const SECONDRY = "SECONDRY";
export const MSISDN = "msisdn"
export const AW_FTTX = "AW_FTTX";
export const PREPAID_TEXT = "prepaid";
export const POSTPAID_TEXT = "postpaid";
export const BROADBAND_TEXT = "broadband";
export const BUNDLE_PURCHASE = "BUNDLE_PURCHASE";
export const SELECTED_LANGUAGE = "selectedLanguage";
export const NEW_THEME = "newTheme";
export const OPCO = "opco";
export const CD = "cd";
export const CD_CAPS = "CD";
export const DRC_CAPS = "DRC";
export const NEW_HF = "newHF";
export const NEW_HOME_CONTENT = "newHomeContent"
export const EN_US_TEXT = "en-US";
export const USD = "USD";
export const CDF = "CDF";
export const SEE_MORE = "SEE_MORE";
export const FTTX_VERSION_TEXT = "fttxVersion";
export const P3_TEXT = "P3";
export const SUMBIT_TEXT = "submit"
export const ENTER_KEY = "Enter"
export const USER_DEVICE_ID = "user_device_id"
export const USER_SESSION_ID = "user_session_id"
export const V3 = "v3"
export const V2 = "v2"
export const PAGE_HIDE_TEXT = "pagehide"
export const KEY_DOWN_TEXT = 'keydown'
export const WHITE_TEXT = "white"
export const ORP_HOME ="ORP_HOME"
export const ORP_HOME_TEXT ="orp_home"
export const GLOBAL_TEXT ="global"
export const LEAD_STATUS_LIST = {
  completed: "completed",
  success: "success",
  created: "created",
  inprogress: "inprogress",
  not_started: "not_started",
  failed: "failed",
  cancelled: "cancelled",
}
export const LEAD_STATUS_ICONS = {
  GREEN_CHECKMARK: 'checkmark-green.svg',
  YELLOW_CHECKMARK: 'checkmark-yellow.svg',
  GRAY_CHECKMARK: 'checkmark-gray.svg',
  RED_CHECKMARK: 'checkmark-red.svg'
}